import { DefaultMantineColorName } from "./types";

export const appColor: Record<string, DefaultMantineColorName> = {
  cycles: "grape",
  employees: "cyan",
  ranges: "yellow",
  autobenchmarking: "violet",
  settings: "orange",
  totalRewards: "lime",
  benchmarking: "teal",
  internalTools: "blue",

  ai: "violet",
  internalOnly: "pink",
};
